import React from "react";

export const ArrowLeftIcon = ({ ...props }: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.2929 4.29289C11.6834 3.90237 12.3166 3.90237 12.7071 4.29289C13.0976 4.68342 13.0976 5.31658 12.7071 5.70711L7.41421 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H7.41421L12.7071 18.2929C13.0976 18.6834 13.0976 19.3166 12.7071 19.7071C12.3166 20.0976 11.6834 20.0976 11.2929 19.7071L4.29361 12.7078C4.29119 12.7054 4.28879 12.703 4.2864 12.7005C4.1099 12.5208 4.0008 12.2746 4 12.003L4 12L4 11.997C4.0004 11.8625 4.02735 11.7343 4.07588 11.6172C4.12357 11.502 4.19374 11.3938 4.2864 11.2995C4.28875 11.297 4.29112 11.2947 4.29351 11.2923M4.29351 11.2923L11.2929 4.29289Z"
        fill="currentColor"
      />
    </svg>
  );
};
